import { Loader } from "@googlemaps/js-api-loader"

export const MapsLoader = new Loader({
    apiKey: process.env.REACT_APP_GMAPS_KEY || (window as any).env?.gmaps_key,
    version: "weekly",
  });

export default MapsLoader;
